"use client";

import { useState, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { Help } from "@churchofjesuschrist/eden-icons";
import EdenCallout from "@churchofjesuschrist/eden-callout";
import { spacing8, accentColorLink } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Callout = styled(EdenCallout).withConfig({
  componentId: "sc-10q14yd-0"
})(["padding:", ";"], spacing8);

/**
 * The Tooltip is used when a long description is needed to describe a form control.
 */
const Tooltip = _ref => {
  let {
    children,
    title = "Additional Details",
    calloutId,
    ...props
  } = _ref;
  const [open, setOpen] = useState(false);
  const iconRef = useRef(null);
  const openCallout = () => {
    setOpen(true);
  };
  const closeCallout = () => {
    setOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Icon, {
      title: title,
      size: "small",
      ref: iconRef,
      onClick: openCallout,
      ...props,
      children: /*#__PURE__*/_jsx(Help, {
        color: accentColorLink
      })
    }), /*#__PURE__*/_jsx(Callout, {
      id: calloutId,
      open: open,
      onClickOutside: closeCallout,
      forRef: iconRef,
      placement: "top",
      children: children
    })]
  });
};
Tooltip.propTypes = {
  /** Advisory information for the tooltip's `Icon` button  */
  title: PropTypes.string,
  /** A unique identification for the tooltip's `Callout` */
  calloutId: PropTypes.string,
  /** Content to render inside tooltip's `Callout` */
  children: PropTypes.node
};
export default Tooltip;